import { createCtx } from './contextFactory';

const [ctx, Provider] = createCtx({
    discussions: []
});

export const NotificationContext = ctx;

export const NotificationProvider = Provider;
